import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnInit, SimpleChanges, inject } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormArray, FormBuilder, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SenderIdAuthorisationItem } from '../../interfaces/sender-id-authorisation-item.interface';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'si-sender-ids-opas-form',
  templateUrl: './sender-ids-opas-form.component.html',
  styleUrls: ['./sender-ids-opas-form.component.scss'],
  standalone: true,
  imports: [MatFormFieldModule, MatButtonModule, ReactiveFormsModule, CommonModule, MatIconModule, FormsModule, MatInputModule, MatCheckboxModule],
  providers: [],
})
export class SenderIdsOpasFormComponent implements OnInit, OnChanges {
  @Input({ required: true }) formArray: FormArray;
  @Input() opas: SenderIdAuthorisationItem[] = [];

  @Input() set disabled(value: boolean) {
    this._disabled = value;
    this.formArray.controls.forEach((control) => {
      if (value) {
        control.disable();
      } else {
        control.enable();
      }
    });
  }

  private _destroy$ = new Subject<void>();
  public _filtredOpas: SenderIdAuthorisationItem[] = [];
  private _disabled = false;

  public readonly fb = inject(FormBuilder);

  public filter = new FormControl('');

  public ngOnInit(): void {
    this.filter.valueChanges
      .pipe(takeUntil(this._destroy$))
      .subscribe((value: string) => {
        this._filtredOpas = this.opas.filter(({ organisationName }) => !value || organisationName.toLowerCase().includes(value.toString().toLowerCase()));
      })
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.opas?.currentValue) {
      this.addOpaControls();
      this._filtredOpas = changes.opas.currentValue;
      this.filter.setValue('', { emitEvent: false });
    }
  }

  private addOpaControls() {
    this.formArray.clear({ emitEvent: false });
    this.opas.forEach(({ accountId }) => {
      this.formArray.push(this.fb.group({
        id: new FormControl(accountId),
        selected: new FormControl({ value: false, disabled: this._disabled }),
      }), { emitEvent: false });
    });
  }

  public getFormControl(id: number) {
    const control = this.formArray.controls.find((control) => control.get('id').value === id);
    return control.get('selected');
  }

  public get hasOpasFormGroupError() {
    return this.formArray.touched && this.formArray.hasError('minChecked');
  }
}
